export interface WorkerTerminalStats {
  pickedToday: number;
  pickedYesterday: number;
  totalToPick: number;
  pickPercentage: number;
}

export interface WorkerOrder {
  id: string;
  shopify_order_id: string;
  order_number: string;
  customer_name: string | null;
  customer_first_name: string | null;
  customer_last_name: string | null;
  customer_email: string | null;
  order_date: string;
  total_price: number;
  currency: string;
  financial_status: string;
  fulfillment_status: string | null;
  line_items: WorkerOrderLineItem[];
  shipping_address: ShippingAddress | null;
}

export interface WorkerOrderLineItem {
  sku: string | null;
  title: string;
  quantity: number;
  price: number;
  fulfillable_quantity?: number;
}

export interface ShippingAddress {
  address1: string;
  address2: string | null;
  city: string;
  province: string | null;
  country: string;
  zip: string;
}

export interface WorkerOrdersResponse {
  orders: WorkerOrder[];
  totalCount: number;
  hasMore: boolean;
}

export interface WorkerTerminalError {
  type: 'connection' | 'auth' | 'data' | 'unknown';
  message: string;
  retryable: boolean;
}

export type SortOption = 'oldest' | 'newest';

export interface PaginationState {
  currentPage: number;
  pageSize: number;
  totalCount: number;
}

export interface ProductLocationInfo {
  id: string;
  barcode: string | null;
  image_url: string | null;
}

export interface BinLocationData {
  product_id: string;
  warehouse_bins: {
    bin_code: string;
    level_number: number;
    warehouse_racks: {
      rack_code: string;
      warehouse_zones: {
        zone_code: string;
      } | null;
    };
  };
}

export type ItemCountFilter = 'all' | 'small' | 'medium' | 'large';

export interface ItemCountFilterOption {
  value: ItemCountFilter;
  label: string;
  shortLabel: string;
  minItems: number | null;
  maxItems: number | null;
}

export interface OrderCountsBySize {
  all: number;
  small: number;
  medium: number;
  large: number;
}

export const ITEM_COUNT_FILTER_OPTIONS: ItemCountFilterOption[] = [
  { value: 'all', label: 'All Orders', shortLabel: 'All', minItems: null, maxItems: null },
  { value: 'small', label: 'Small (1-4)', shortLabel: '1-4', minItems: 1, maxItems: 4 },
  { value: 'medium', label: 'Medium (5-8)', shortLabel: '5-8', minItems: 5, maxItems: 8 },
  { value: 'large', label: 'Large (9+)', shortLabel: '9+', minItems: 9, maxItems: null },
];
